import React from "react";
import {withErrorBoundary} from "../ErrorBoundary";


const PhoneLink = ({children, href, className}) => {
  return (
    <a className={className} href={`tel: ${href || children.replace(/[^+\d]/g, "")}`} onClick={(event) => event.stopPropagation()}>
        {children}
    </a>
  );
};

export default withErrorBoundary(PhoneLink);